module.exports = __webpack_public_path__ + "static/media/5.66d118ea.png";